// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: block;
}

::ng-deep .mat-mdc-dialog-container,
::ng-deep .mat-dialog-container {
  border-radius: 22px !important;
  overflow: hidden !important;
  padding: 0 !important;
}

::ng-deep .mat-mdc-dialog-surface {
  border-radius: 22px !important;
  overflow: hidden !important;
}

.version-panel {
  width: 100% !important;
  max-width: 800px;
  min-width: 500px;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 88vh;
  position: relative;
}

.version-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #ffffff;
  position: relative;
  z-index: 2;
}
.version-header h2 {
  margin: 0;
  font-size: 20px !important;
  font-weight: 600;
  color: #212427;
  text-align: left;
  padding-right: 48px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.version-header .subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #666;
}
.version-header .close-button {
  color: #666;
}
.version-header button[mat-icon-button] {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #666;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
.version-header button[mat-icon-button] mat-icon {
  color: #666;
}
.version-header button[mat-icon-button]:hover {
  background: transparent !important;
}
.version-header button[mat-icon-button]:focus, .version-header button[mat-icon-button]:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.version-list {
  max-height: 280px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
}
.version-list::-webkit-scrollbar {
  width: 6px;
}
.version-list::-webkit-scrollbar-track {
  background: transparent;
}
.version-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.16);
  border-radius: 999px;
}

.version-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.15s ease;
}
.version-row.current {
  background-color: #f5f9ff;
}
.version-row:hover {
  background-color: #f8f9fb;
}
.version-row:last-child {
  border-bottom: none;
}

.meta {
  flex: 1;
  min-width: 0;
}

.title-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.version-select-checkbox {
  margin-right: 4px;
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 10px;
  border-radius: 4px;
  background-color: #5ea1d8;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.current-chip {
  padding: 3px 10px;
  border-radius: 4px;
  background-color: #4caf50;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
}

.version-title {
  font-weight: 500;
  font-size: 14px;
  color: #212427;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.details {
  margin-top: 4px;
  font-size: 12px;
  color: #666;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.dot {
  font-size: 10px;
  color: #999;
}

.collab-label {
  font-size: 12px;
  color: #666;
}

.collab-avatars {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.collab-avatar-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1.5px solid #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  flex-shrink: 0;
  background: #e2e8f0;
}

.collab-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.collab-avatar-fallback {
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  line-height: 1;
  text-transform: uppercase;
}

.actions {
  display: flex;
  gap: 8px;
  margin-left: 16px;
  flex-shrink: 0;
}
.actions button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* Preview button (mat-stroked-button color="primary") */
::ng-deep .version-panel .actions .mat-mdc-outlined-button.mat-primary,
::ng-deep .version-panel .actions .mat-mdc-stroked-button.mat-primary {
  --mdc-outlined-button-outline-color: #5ea1d8;
  --mdc-outlined-button-label-text-color: #5ea1d8;
  border: 1.5px solid #5ea1d8 !important;
  color: #5ea1d8 !important;
  background: transparent !important;
  border-radius: 6px !important;
  min-width: 72px !important;
  height: 34px !important;
  padding: 0 14px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}
::ng-deep .version-panel .actions .mat-mdc-outlined-button.mat-primary .mdc-button__label,
::ng-deep .version-panel .actions .mat-mdc-stroked-button.mat-primary .mdc-button__label {
  color: #5ea1d8 !important;
}
::ng-deep .version-panel .actions .mat-mdc-outlined-button.mat-primary:hover:not([disabled]),
::ng-deep .version-panel .actions .mat-mdc-stroked-button.mat-primary:hover:not([disabled]) {
  background: rgba(94, 161, 216, 0.1) !important;
}
::ng-deep .version-panel .actions .mat-mdc-outlined-button.mat-primary[disabled],
::ng-deep .version-panel .actions .mat-mdc-stroked-button.mat-primary[disabled] {
  opacity: 0.45;
}

/* Restore button (mat-flat-button color="primary") */
::ng-deep .version-panel .actions .mat-mdc-unelevated-button.mat-primary {
  --mdc-filled-button-container-color: #5ea1d8;
  --mdc-filled-button-label-text-color: #ffffff;
  background: #5ea1d8 !important;
  border: 1.5px solid #5ea1d8 !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  min-width: 72px !important;
  height: 34px !important;
  padding: 0 14px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}
::ng-deep .version-panel .actions .mat-mdc-unelevated-button.mat-primary .mdc-button__label {
  color: #ffffff !important;
}
::ng-deep .version-panel .actions .mat-mdc-unelevated-button.mat-primary:hover:not([disabled]) {
  background: #4a8dc4 !important;
  border-color: #4a8dc4 !important;
}
::ng-deep .version-panel .actions .mat-mdc-unelevated-button.mat-primary[disabled] {
  opacity: 0.45;
}

/* Delete button (mat-stroked-button color="warn") */
::ng-deep .version-panel .actions .mat-mdc-outlined-button.mat-warn,
::ng-deep .version-panel .actions .mat-mdc-stroked-button.mat-warn {
  --mdc-outlined-button-outline-color: #ef4444;
  --mdc-outlined-button-label-text-color: #ef4444;
  border: 1.5px solid #ef4444 !important;
  color: #ef4444 !important;
  background: transparent !important;
  border-radius: 6px !important;
  min-width: 72px !important;
  height: 34px !important;
  padding: 0 14px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}
::ng-deep .version-panel .actions .mat-mdc-outlined-button.mat-warn .mdc-button__label,
::ng-deep .version-panel .actions .mat-mdc-stroked-button.mat-warn .mdc-button__label {
  color: #ef4444 !important;
}
::ng-deep .version-panel .actions .mat-mdc-outlined-button.mat-warn:hover:not([disabled]),
::ng-deep .version-panel .actions .mat-mdc-stroked-button.mat-warn:hover:not([disabled]) {
  background: rgba(239, 68, 68, 0.08) !important;
}
::ng-deep .version-panel .actions .mat-mdc-outlined-button.mat-warn[disabled],
::ng-deep .version-panel .actions .mat-mdc-stroked-button.mat-warn[disabled] {
  opacity: 0.45;
}

.btn-loader {
  display: inline-block;
}

.loading,
.error {
  padding: 24px;
  text-align: center;
}

.preview {
  border-top: 1px solid #e0e0e0;
  padding: 24px;
  margin-top: 0;
  background: #fff;
}
.preview h3 {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: bold;
  color: #212427;
  text-align: left;
}
.preview .preview-meta {
  margin: 0 0 12px;
  font-size: 12px;
  color: #666;
  text-align: left;
}
.preview .preview-body {
  font-size: 14px;
  line-height: 1.5;
  color: #212427;
  text-align: left;
}

/* Slight tweaks to the shared view-flow video-player-section when used inside the dialog */
.preview-video-player {
  margin: 8px 0 10px;
  border-radius: 10px;
  overflow: hidden;
}
.preview-video-player .img-wrap {
  padding-bottom: 56.25%; /* keep 16:9 aspect like view-flow */
}

.empty-state {
  font-size: 14px;
  color: #666;
  text-align: center;
  padding: 24px;
}

/* Flow-style two-column preview layout (mirrors view-flow: main + sidebar) */
.preview-flow-layout {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(260px, 1fr);
  gap: 16px;
  margin-top: 8px;
  align-items: flex-start;
}
.preview-flow-layout .preview-flow-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.preview-flow-layout .preview-flow-sidebar {
  min-width: 0;
}

.preview-description-card {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 10px 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid #eee;
}
.preview-description-card h4 {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
}
.preview-description-card .preview-description-body {
  max-height: 180px;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.4;
}

/* Right side step navigation reuses global .step-navigation / .steps-list styles */
.preview-steps-wrapper {
  background: #ffffff;
  border-radius: 10px;
  padding: 10px 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid #eee;
}
.preview-steps-wrapper h4 {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
}
.preview-steps-wrapper .step-scroll {
  max-height: 220px;
}

.step-media-thumb {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
}
.step-media-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.step-media-thumb .step-media-icon {
  font-size: 22px;
  color: #fff;
}

.comparison {
  margin: 0;
  padding: 24px;
  border-top: 1px solid #e0e0e0;
  font-size: 14px;
  background: #fff;
}
.comparison .comparison-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: bold;
  color: #212427;
  text-align: left;
}
.comparison .comparison-hint {
  margin: 0 0 8px;
  color: #666;
  font-size: 13px;
  text-align: left;
}
.comparison .comparison-loading {
  color: #666;
  font-style: italic;
}
.comparison .comparison-error {
  color: #c62828;
}
.comparison .comparison-list {
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
  max-height: 320px;
  overflow-y: auto;
  padding-right: 4px;
}
.comparison .comparison-list::-webkit-scrollbar {
  width: 5px;
}
.comparison .comparison-list::-webkit-scrollbar-track {
  background: transparent;
}
.comparison .comparison-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.16);
  border-radius: 999px;
}

/* ── Diff item cards ──────────────────────────────────────────── */
.diff-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 9px 14px 9px 12px;
  border-radius: 8px;
  border-left: 4px solid transparent;
  font-size: 13px;
  line-height: 1.5;
  /* ── Added — green ── */
  /* ── Removed — red ── */
  /* ── Changed — amber/orange ── */
  /* ── Info — blue ── */
}
.diff-item .diff-badge {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
  margin-top: 1px;
  color: #fff;
}
.diff-item .diff-text {
  flex: 1;
  word-break: break-word;
}
.diff-item.diff-added {
  background: #f0fdf4;
  border-left-color: #16a34a;
}
.diff-item.diff-added .diff-badge {
  background: #16a34a;
}
.diff-item.diff-added .diff-text {
  color: #14532d;
}
.diff-item.diff-removed {
  background: #fff1f2;
  border-left-color: #dc2626;
}
.diff-item.diff-removed .diff-badge {
  background: #dc2626;
}
.diff-item.diff-removed .diff-text {
  color: #7f1d1d;
}
.diff-item.diff-changed {
  background: #fffbeb;
  border-left-color: #d97706;
}
.diff-item.diff-changed .diff-badge {
  background: #d97706;
}
.diff-item.diff-changed .diff-text {
  color: #78350f;
}
.diff-item.diff-info {
  background: #eff6ff;
  border-left-color: #2563eb;
}
.diff-item.diff-info .diff-badge {
  background: #2563eb;
}
.diff-item.diff-info .diff-text {
  color: #1e3a8a;
}

@media (max-width: 640px) {
  .version-panel {
    max-width: 100%;
    min-width: auto;
    border-radius: 16px;
  }
  .version-header {
    padding: 16px;
  }
  .version-header h2 {
    font-size: 18px;
    padding-right: 40px;
  }
  .version-header .subtitle {
    font-size: 12px;
  }
  .version-header button[mat-icon-button] {
    top: 8px;
    right: 8px;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .version-list {
    max-height: 200px;
  }
  .comparison-list {
    max-height: 220px;
  }
  .version-row {
    padding: 12px 16px;
    flex-wrap: wrap;
    gap: 10px;
  }
  .version-row .meta {
    width: 100%;
  }
  .version-row .actions {
    width: 100%;
    justify-content: flex-end;
    margin-left: 0;
  }
  .preview-flow-layout {
    grid-template-columns: 1fr;
  }
  .preview,
  .comparison {
    padding: 16px;
  }
}
/* Dark mode: dialog content must match overlay palette; nested .view-flow preview
   is outside viewflow.component host so page-level view-flow dark rules do not apply. */
:host-context(body.theme-dark) {
  /* Keep action buttons clearly styled in dark mode */
  /* ── Diff cards — dark mode ── */
  /* Flow version preview: align with view-flow dark styling (see viewflow.component.scss) */
}
:host-context(body.theme-dark) .version-panel {
  background: #111827 !important;
  box-shadow: 0 35px 70px rgba(0, 0, 0, 0.55);
}
:host-context(body.theme-dark) .version-header {
  background: #111827 !important;
  border-bottom-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .version-header h2 {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .version-header .subtitle {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .version-header button[mat-icon-button] mat-icon {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .version-list::-webkit-scrollbar-thumb,
:host-context(body.theme-dark) .comparison-list::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.35);
}
:host-context(body.theme-dark) .version-row {
  border-bottom-color: rgba(148, 163, 184, 0.22) !important;
}
:host-context(body.theme-dark) .version-row.current {
  background-color: rgba(94, 161, 216, 0.14) !important;
}
:host-context(body.theme-dark) .version-row:hover {
  background-color: rgba(148, 163, 184, 0.08) !important;
}
:host-context(body.theme-dark) .version-title {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .details {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .dot {
  color: #64748b !important;
}
:host-context(body.theme-dark) .collab-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .collab-avatar-wrap {
  background: #334155 !important;
  border-color: #1e293b !important;
  box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .collab-avatar-fallback {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .empty-state {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .loading,
:host-context(body.theme-dark) .error {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .actions .mat-mdc-outlined-button.mat-primary,
:host-context(body.theme-dark) .actions .mat-mdc-stroked-button.mat-primary {
  --mdc-outlined-button-outline-color: #7bbde8 !important;
  --mdc-outlined-button-label-text-color: #7bbde8 !important;
  border-color: #7bbde8 !important;
  color: #7bbde8 !important;
}
:host-context(body.theme-dark) .actions .mat-mdc-outlined-button.mat-primary .mdc-button__label,
:host-context(body.theme-dark) .actions .mat-mdc-stroked-button.mat-primary .mdc-button__label {
  color: #7bbde8 !important;
}
:host-context(body.theme-dark) .actions .mat-mdc-unelevated-button.mat-primary {
  --mdc-filled-button-container-color: #5ea1d8 !important;
  background: #5ea1d8 !important;
  border-color: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .actions .mat-mdc-unelevated-button.mat-primary .mdc-button__label {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .actions .mat-mdc-outlined-button.mat-warn,
:host-context(body.theme-dark) .actions .mat-mdc-stroked-button.mat-warn {
  --mdc-outlined-button-outline-color: #f87171 !important;
  --mdc-outlined-button-label-text-color: #f87171 !important;
  border-color: #f87171 !important;
  color: #f87171 !important;
}
:host-context(body.theme-dark) .actions .mat-mdc-outlined-button.mat-warn .mdc-button__label,
:host-context(body.theme-dark) .actions .mat-mdc-stroked-button.mat-warn .mdc-button__label {
  color: #f87171 !important;
}
:host-context(body.theme-dark) .preview {
  background: #111827 !important;
  border-top-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .preview h3 {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .preview .preview-meta {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .preview .preview-body {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .preview .preview-description h4 {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .comparison {
  background: #111827 !important;
  border-top-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .comparison .comparison-title {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .comparison .comparison-hint,
:host-context(body.theme-dark) .comparison .comparison-loading {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .comparison .comparison-error {
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) .comparison .comparison-list li {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .diff-item.diff-added {
  background: rgba(74, 222, 128, 0.12) !important;
  border-left-color: #4ade80 !important;
}
:host-context(body.theme-dark) .diff-item.diff-added .diff-badge {
  background: #4ade80 !important;
  color: #052e16 !important;
}
:host-context(body.theme-dark) .diff-item.diff-added .diff-text {
  color: #86efac !important;
}
:host-context(body.theme-dark) .diff-item.diff-removed {
  background: rgba(248, 113, 113, 0.12) !important;
  border-left-color: #f87171 !important;
}
:host-context(body.theme-dark) .diff-item.diff-removed .diff-badge {
  background: #f87171 !important;
  color: #450a0a !important;
}
:host-context(body.theme-dark) .diff-item.diff-removed .diff-text {
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) .diff-item.diff-changed {
  background: rgba(251, 191, 36, 0.12) !important;
  border-left-color: #fbbf24 !important;
}
:host-context(body.theme-dark) .diff-item.diff-changed .diff-badge {
  background: #fbbf24 !important;
  color: #451a03 !important;
}
:host-context(body.theme-dark) .diff-item.diff-changed .diff-text {
  color: #fde68a !important;
}
:host-context(body.theme-dark) .diff-item.diff-info {
  background: rgba(96, 165, 250, 0.12) !important;
  border-left-color: #60a5fa !important;
}
:host-context(body.theme-dark) .diff-item.diff-info .diff-badge {
  background: #60a5fa !important;
  color: #172554 !important;
}
:host-context(body.theme-dark) .diff-item.diff-info .diff-text {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .preview-description-card,
:host-context(body.theme-dark) .preview-steps-wrapper {
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .preview-description-card h4,
:host-context(body.theme-dark) .preview-steps-wrapper h4 {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .version-panel .view-flow,
:host-context(body.theme-dark) .version-panel .view-flow .container1,
:host-context(body.theme-dark) .version-panel .view-flow .flow-layout-container,
:host-context(body.theme-dark) .version-panel .view-flow .flow-main-grid,
:host-context(body.theme-dark) .version-panel .view-flow .flow-main-content,
:host-context(body.theme-dark) .version-panel .view-flow .video-player-section,
:host-context(body.theme-dark) .version-panel .view-flow .flow-sidebar,
:host-context(body.theme-dark) .version-panel .view-flow .step-navigation,
:host-context(body.theme-dark) .version-panel .view-flow .step-scroll,
:host-context(body.theme-dark) .version-panel .view-flow .steps-list {
  background: #0f172a !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .flow-title-sticky {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .video-title-sticky {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .description-section {
  background: #0f172a !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .description-section h3 {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .description-content {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .description-content a {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .no-steps {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .step-navigation .step-btn {
  background: #f8fafc !important;
  color: #111827 !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .step-navigation .step-btn .step-title,
:host-context(body.theme-dark) .version-panel .view-flow .step-navigation .step-btn .step-index {
  color: #111827 !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .step-navigation .step-btn mat-icon {
  color: #111827 !important;
}
:host-context(body.theme-dark) .version-panel .view-flow .preview-video-player .img-wrap {
  background: #020617 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/version-history-panel/version-history-panel.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,cAAA;AACF;;AAEA;;EAEE,8BAAA;EACA,2BAAA;EACA,qBAAA;AACF;;AAEA;EACE,8BAAA;EACA,2BAAA;AACF;;AAEA;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AACF;AACE;EACE,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;AAEE;EACE,eAAA;EACA,eAAA;EACA,WAAA;AAAJ;AAGE;EACE,WAAA;AADJ;AAIE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;EACA,uBAAA;EACA,2BAAA;AAFJ;AAII;EACE,WAAA;AAFN;AAKI;EACE,kCAAA;AAHN;AAMI;EAEE,wBAAA;EACA,2BAAA;AALN;;AAUA;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAPF;AASE;EACE,UAAA;AAPJ;AAUE;EACE,uBAAA;AARJ;AAWE;EACE,+BAAA;EACA,oBAAA;AATJ;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,uCAAA;AAVF;AAYE;EACE,yBAAA;AAVJ;AAaE;EACE,yBAAA;AAXJ;AAcE;EACE,mBAAA;AAZJ;;AAgBA;EACE,OAAA;EACA,YAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAbF;;AAgBA;EACE,iBAAA;AAbF;;AAgBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,WAAA;AAbF;;AAgBA;EACE,eAAA;EACA,WAAA;AAbF;;AAgBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAbF;;AAgBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,yCAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAbF;;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;AAbF;AAeE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAbJ;;AAiBA,wDAAA;AACA;;EAEE,4CAAA;EACA,+CAAA;EACA,sCAAA;EACA,yBAAA;EACA,kCAAA;EACA,6BAAA;EACA,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;AAdF;AAgBE;;EAAqB,yBAAA;AAZvB;AAcE;;EAA0B,8CAAA;AAV5B;AAWE;;EAAc,aAAA;AAPhB;;AAUA,qDAAA;AACA;EACE,4CAAA;EACA,6CAAA;EACA,8BAAA;EACA,sCAAA;EACA,yBAAA;EACA,6BAAA;EACA,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;AAPF;AASE;EAAqB,yBAAA;AANvB;AAQE;EACE,8BAAA;EACA,gCAAA;AANJ;AAQE;EAAc,aAAA;AALhB;;AAQA,oDAAA;AACA;;EAEE,4CAAA;EACA,+CAAA;EACA,sCAAA;EACA,yBAAA;EACA,kCAAA;EACA,6BAAA;EACA,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;AALF;AAOE;;EAAqB,yBAAA;AAHvB;AAKE;;EAA0B,8CAAA;AAD5B;AAEE;;EAAc,aAAA;AAEhB;;AACA;EACE,qBAAA;AAEF;;AACA;;EAEE,aAAA;EACA,kBAAA;AAEF;;AACA;EACE,6BAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;AAEF;AAAE;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAEJ;AACE;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAAJ;;AAIA,2FAAA;AACA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAGE;EACE,sBAAA,EAAA,oCAAA;AADJ;;AAKA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAFF;;AAKA,6EAAA;AACA;EACE,aAAA;EACA,0DAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;AAFF;AAIE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFJ;AAKE;EACE,YAAA;AAHJ;;AAOA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,sBAAA;AAJF;AAME;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAJJ;AAOE;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AALJ;;AASA,mFAAA;AACA;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,sBAAA;AANF;AAQE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AANJ;AASE;EACE,iBAAA;AAPJ;;AAWA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AARF;AAUE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AARJ;AAWE;EACE,eAAA;EACA,WAAA;AATJ;;AAaA;EACE,SAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AAVF;AAYE;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAVJ;AAaE;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAXJ;AAcE;EACE,WAAA;EACA,kBAAA;AAZJ;AAeE;EACE,cAAA;AAbJ;AAgBE;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAdJ;AAgBI;EACE,UAAA;AAdN;AAgBI;EACE,uBAAA;AAdN;AAgBI;EACE,+BAAA;EACA,oBAAA;AAdN;;AAmBA,oEAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,0BAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EAsBA,wBAAA;EAQA,wBAAA;EAQA,iCAAA;EAQA,sBAAA;AA1DF;AAcE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AAZJ;AAeE;EACE,OAAA;EACA,sBAAA;AAbJ;AAiBE;EACE,mBAAA;EACA,0BAAA;AAfJ;AAgBI;EAAe,mBAAA;AAbnB;AAcI;EAAe,cAAA;AAXnB;AAeE;EACE,mBAAA;EACA,0BAAA;AAbJ;AAcI;EAAe,mBAAA;AAXnB;AAYI;EAAe,cAAA;AATnB;AAaE;EACE,mBAAA;EACA,0BAAA;AAXJ;AAYI;EAAe,mBAAA;AATnB;AAUI;EAAe,cAAA;AAPnB;AAWE;EACE,mBAAA;EACA,0BAAA;AATJ;AAUI;EAAe,mBAAA;AAPnB;AAQI;EAAe,cAAA;AALnB;;AASA;EACE;IACE,eAAA;IACA,eAAA;IAEA,mBAAA;EAPF;EAUA;IACE,aAAA;EARF;EAUE;IACE,eAAA;IACA,mBAAA;EARJ;EAWE;IACE,eAAA;EATJ;EAYE;IACE,QAAA;IACA,UAAA;IACA,kCAAA;IACA,uBAAA;IACA,2BAAA;EAVJ;EAcA;IACE,iBAAA;EAZF;EAeA;IACE,iBAAA;EAbF;EAgBA;IACE,kBAAA;IACA,eAAA;IACA,SAAA;EAdF;EAgBE;IACE,WAAA;EAdJ;EAiBE;IACE,WAAA;IACA,yBAAA;IACA,cAAA;EAfJ;EAmBA;IACE,0BAAA;EAjBF;EAoBA;;IAEE,aAAA;EAlBF;AACF;AAqBA;wFAAA;AAEA;EA6EE,oDAAA;EAsEA,iCAAA;EAuCA,0FAAA;AA1MF;AAiBE;EACE,8BAAA;EACA,2CAAA;AAfJ;AAkBE;EACE,8BAAA;EACA,yDAAA;AAhBJ;AAkBI;EACE,yBAAA;AAhBN;AAmBI;EACE,yBAAA;AAjBN;AAoBI;EACE,yBAAA;AAlBN;AAwBI;;EACE,qCAAA;AArBN;AAyBE;EACE,yDAAA;AAvBJ;AAyBI;EACE,qDAAA;AAvBN;AA0BI;EACE,sDAAA;AAxBN;AA4BE;EACE,yBAAA;AA1BJ;AA6BE;EACE,yBAAA;AA3BJ;AA8BE;EACE,yBAAA;AA5BJ;AA+BE;EACE,yBAAA;AA7BJ;AAgCE;EACE,8BAAA;EACA,gCAAA;EACA,0DAAA;AA9BJ;AAiCE;EACE,yBAAA;AA/BJ;AAkCE;EACE,yBAAA;AAhCJ;AAmCE;;EAEE,yBAAA;AAjCJ;AAqCE;;EAEE,uDAAA;EACA,0DAAA;EACA,gCAAA;EACA,yBAAA;AAnCJ;AAoCI;;EAAqB,yBAAA;AAhCzB;AAmCE;EACE,uDAAA;EACA,8BAAA;EACA,gCAAA;EACA,yBAAA;AAjCJ;AAkCI;EAAqB,yBAAA;AA/BzB;AAkCE;;EAEE,uDAAA;EACA,0DAAA;EACA,gCAAA;EACA,yBAAA;AAhCJ;AAiCI;;EAAqB,yBAAA;AA7BzB;AAgCE;EACE,8BAAA;EACA,sDAAA;AA9BJ;AAgCI;EACE,yBAAA;AA9BN;AAiCI;EACE,yBAAA;AA/BN;AAkCI;EACE,yBAAA;AAhCN;AAmCI;EACE,yBAAA;AAjCN;AAqCE;EACE,8BAAA;EACA,sDAAA;AAnCJ;AAqCI;EACE,yBAAA;AAnCN;AAsCI;;EAEE,yBAAA;AApCN;AAuCI;EACE,yBAAA;AArCN;AAwCI;EACE,yBAAA;AAtCN;AA4CI;EACE,+CAAA;EACA,qCAAA;AA1CN;AA2CM;EAAc,8BAAA;EAAgC,yBAAA;AAvCpD;AAwCM;EAAc,yBAAA;AArCpB;AAuCI;EACE,gDAAA;EACA,qCAAA;AArCN;AAsCM;EAAc,8BAAA;EAAgC,yBAAA;AAlCpD;AAmCM;EAAc,yBAAA;AAhCpB;AAkCI;EACE,+CAAA;EACA,qCAAA;AAhCN;AAiCM;EAAc,8BAAA;EAAgC,yBAAA;AA7BpD;AA8BM;EAAc,yBAAA;AA3BpB;AA6BI;EACE,+CAAA;EACA,qCAAA;AA3BN;AA4BM;EAAc,8BAAA;EAAgC,yBAAA;AAxBpD;AAyBM;EAAc,yBAAA;AAtBpB;AA0BE;;EAEE,oCAAA;EACA,kDAAA;EACA,2BAAA;AAxBJ;AA0BI;;EACE,yBAAA;AAvBN;AA4BE;;;;;;;;;;EAUE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA1BJ;AA6BE;EACE,8BAAA;EACA,kDAAA;AA3BJ;AA8BE;EACE,yBAAA;AA5BJ;AA+BE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA7BJ;AAgCE;EACE,yBAAA;AA9BJ;AAiCE;EACE,yBAAA;AA/BJ;AAiCI;EACE,yBAAA;AA/BN;AAmCE;EACE,yBAAA;AAjCJ;AAoCE;EACE,8BAAA;EACA,yBAAA;AAlCJ;AAqCE;;EAEE,yBAAA;AAnCJ;AAsCE;EACE,yBAAA;AApCJ;AAuCE;EACE,8BAAA;AArCJ","sourcesContent":["// Style the Material Dialog container to have rounded corners\n:host {\n  display: block;\n}\n\n::ng-deep .mat-mdc-dialog-container,\n::ng-deep .mat-dialog-container {\n  border-radius: 22px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n}\n\n::ng-deep .mat-mdc-dialog-surface {\n  border-radius: 22px !important;\n  overflow: hidden !important;\n}\n\n.version-panel {\n  width: 100% !important;\n  max-width: 800px;\n  min-width: 500px;\n  padding: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 22px;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: 88vh;\n  position: relative;\n}\n\n.version-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #ffffff;\n  position: relative;\n  z-index: 2;\n\n  h2 {\n    margin: 0;\n    font-size: 20px !important;\n    font-weight: 600;\n    color: #212427;\n    text-align: left;\n    padding-right: 48px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .subtitle {\n    margin: 4px 0 0;\n    font-size: 13px;\n    color: #666;\n  }\n\n  .close-button {\n    color: #666;\n  }\n\n  button[mat-icon-button] {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    color: #666;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n\n    mat-icon {\n      color: #666;\n    }\n\n    &:hover {\n      background: transparent !important;\n    }\n\n    &:focus,\n    &:focus-visible {\n      outline: none !important;\n      box-shadow: none !important;\n    }\n  }\n}\n\n.version-list {\n  max-height: 280px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 0;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.16);\n    border-radius: 999px;\n  }\n}\n\n.version-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  transition: background-color 0.15s ease;\n\n  &.current {\n    background-color: #f5f9ff;\n  }\n\n  &:hover {\n    background-color: #f8f9fb;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.title-line {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.version-select-checkbox {\n  margin-right: 4px;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px 10px;\n  border-radius: 4px;\n  background-color: #5ea1d8;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.current-chip {\n  padding: 3px 10px;\n  border-radius: 4px;\n  background-color: #4caf50;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.version-title {\n  font-weight: 500;\n  font-size: 14px;\n  color: #212427;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.details {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #666;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.dot {\n  font-size: 10px;\n  color: #999;\n}\n\n.collab-label {\n  font-size: 12px;\n  color: #666;\n}\n\n.collab-avatars {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.collab-avatar-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 1.5px solid #fff;\n  box-shadow: 0 0 0 1px rgba(0,0,0,0.12);\n  overflow: hidden;\n  flex-shrink: 0;\n  background: #e2e8f0;\n}\n\n.collab-avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.collab-avatar-fallback {\n  font-size: 11px;\n  font-weight: 600;\n  color: #475569;\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.actions {\n  display: flex;\n  gap: 8px;\n  margin-left: 16px;\n  flex-shrink: 0;\n\n  button {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n  }\n}\n\n/* Preview button (mat-stroked-button color=\"primary\") */\n::ng-deep .version-panel .actions .mat-mdc-outlined-button.mat-primary,\n::ng-deep .version-panel .actions .mat-mdc-stroked-button.mat-primary {\n  --mdc-outlined-button-outline-color: #5ea1d8;\n  --mdc-outlined-button-label-text-color: #5ea1d8;\n  border: 1.5px solid #5ea1d8 !important;\n  color: #5ea1d8 !important;\n  background: transparent !important;\n  border-radius: 6px !important;\n  min-width: 72px !important;\n  height: 34px !important;\n  padding: 0 14px !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n\n  .mdc-button__label { color: #5ea1d8 !important; }\n\n  &:hover:not([disabled]) { background: rgba(94, 161, 216, 0.1) !important; }\n  &[disabled] { opacity: 0.45; }\n}\n\n/* Restore button (mat-flat-button color=\"primary\") */\n::ng-deep .version-panel .actions .mat-mdc-unelevated-button.mat-primary {\n  --mdc-filled-button-container-color: #5ea1d8;\n  --mdc-filled-button-label-text-color: #ffffff;\n  background: #5ea1d8 !important;\n  border: 1.5px solid #5ea1d8 !important;\n  color: #ffffff !important;\n  border-radius: 6px !important;\n  min-width: 72px !important;\n  height: 34px !important;\n  padding: 0 14px !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n\n  .mdc-button__label { color: #ffffff !important; }\n\n  &:hover:not([disabled]) {\n    background: #4a8dc4 !important;\n    border-color: #4a8dc4 !important;\n  }\n  &[disabled] { opacity: 0.45; }\n}\n\n/* Delete button (mat-stroked-button color=\"warn\") */\n::ng-deep .version-panel .actions .mat-mdc-outlined-button.mat-warn,\n::ng-deep .version-panel .actions .mat-mdc-stroked-button.mat-warn {\n  --mdc-outlined-button-outline-color: #ef4444;\n  --mdc-outlined-button-label-text-color: #ef4444;\n  border: 1.5px solid #ef4444 !important;\n  color: #ef4444 !important;\n  background: transparent !important;\n  border-radius: 6px !important;\n  min-width: 72px !important;\n  height: 34px !important;\n  padding: 0 14px !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n\n  .mdc-button__label { color: #ef4444 !important; }\n\n  &:hover:not([disabled]) { background: rgba(239, 68, 68, 0.08) !important; }\n  &[disabled] { opacity: 0.45; }\n}\n\n.btn-loader {\n  display: inline-block;\n}\n\n.loading,\n.error {\n  padding: 24px;\n  text-align: center;\n}\n\n.preview {\n  border-top: 1px solid #e0e0e0;\n  padding: 24px;\n  margin-top: 0;\n  background: #fff;\n\n  h3 {\n    margin: 0 0 8px;\n    font-size: 16px;\n    font-weight: bold;\n    color: #212427;\n    text-align: left;\n  }\n\n  .preview-meta {\n    margin: 0 0 12px;\n    font-size: 12px;\n    color: #666;\n    text-align: left;\n  }\n\n  .preview-body {\n    font-size: 14px;\n    line-height: 1.5;\n    color: #212427;\n    text-align: left;\n  }\n}\n\n/* Slight tweaks to the shared view-flow video-player-section when used inside the dialog */\n.preview-video-player {\n  margin: 8px 0 10px;\n  border-radius: 10px;\n  overflow: hidden;\n\n  .img-wrap {\n    padding-bottom: 56.25%; /* keep 16:9 aspect like view-flow */\n  }\n}\n\n.empty-state {\n  font-size: 14px;\n  color: #666;\n  text-align: center;\n  padding: 24px;\n}\n\n/* Flow-style two-column preview layout (mirrors view-flow: main + sidebar) */\n.preview-flow-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 2.2fr) minmax(260px, 1fr);\n  gap: 16px;\n  margin-top: 8px;\n  align-items: flex-start;\n\n  .preview-flow-main {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .preview-flow-sidebar {\n    min-width: 0;\n  }\n}\n\n.preview-description-card {\n  background-color: #ffffff;\n  border-radius: 10px;\n  padding: 10px 12px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n  border: 1px solid #eee;\n\n  h4 {\n    margin: 0 0 8px;\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  .preview-description-body {\n    max-height: 180px;\n    overflow-y: auto;\n    font-size: 13px;\n    line-height: 1.4;\n  }\n}\n\n/* Right side step navigation reuses global .step-navigation / .steps-list styles */\n.preview-steps-wrapper {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 10px 12px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n  border: 1px solid #eee;\n\n  h4 {\n    margin: 0 0 8px;\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  .step-scroll {\n    max-height: 220px;\n  }\n}\n\n.step-media-thumb {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  overflow: hidden;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #000;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n\n  .step-media-icon {\n    font-size: 22px;\n    color: #fff;\n  }\n}\n\n.comparison {\n  margin: 0;\n  padding: 24px;\n  border-top: 1px solid #e0e0e0;\n  font-size: 14px;\n  background: #fff;\n\n  .comparison-title {\n    margin: 0 0 8px;\n    font-size: 16px;\n    font-weight: bold;\n    color: #212427;\n    text-align: left;\n  }\n\n  .comparison-hint {\n    margin: 0 0 8px;\n    color: #666;\n    font-size: 13px;\n    text-align: left;\n  }\n\n  .comparison-loading {\n    color: #666;\n    font-style: italic;\n  }\n\n  .comparison-error {\n    color: #c62828;\n  }\n\n  .comparison-list {\n    margin: 12px 0 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    text-align: left;\n    max-height: 320px;\n    overflow-y: auto;\n    padding-right: 4px;\n\n    &::-webkit-scrollbar {\n      width: 5px;\n    }\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n    &::-webkit-scrollbar-thumb {\n      background: rgba(0, 0, 0, 0.16);\n      border-radius: 999px;\n    }\n  }\n}\n\n/* ── Diff item cards ──────────────────────────────────────────── */\n.diff-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 9px 14px 9px 12px;\n  border-radius: 8px;\n  border-left: 4px solid transparent;\n  font-size: 13px;\n  line-height: 1.5;\n\n  .diff-badge {\n    flex-shrink: 0;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 800;\n    line-height: 1;\n    margin-top: 1px;\n    color: #fff;\n  }\n\n  .diff-text {\n    flex: 1;\n    word-break: break-word;\n  }\n\n  /* ── Added — green ── */\n  &.diff-added {\n    background: #f0fdf4;\n    border-left-color: #16a34a;\n    .diff-badge  { background: #16a34a; }\n    .diff-text   { color: #14532d; }\n  }\n\n  /* ── Removed — red ── */\n  &.diff-removed {\n    background: #fff1f2;\n    border-left-color: #dc2626;\n    .diff-badge  { background: #dc2626; }\n    .diff-text   { color: #7f1d1d; }\n  }\n\n  /* ── Changed — amber/orange ── */\n  &.diff-changed {\n    background: #fffbeb;\n    border-left-color: #d97706;\n    .diff-badge  { background: #d97706; }\n    .diff-text   { color: #78350f; }\n  }\n\n  /* ── Info — blue ── */\n  &.diff-info {\n    background: #eff6ff;\n    border-left-color: #2563eb;\n    .diff-badge  { background: #2563eb; }\n    .diff-text   { color: #1e3a8a; }\n  }\n}\n\n@media (max-width: 640px) {\n  .version-panel {\n    max-width: 100%;\n    min-width: auto;\n    // margin: 8px;\n    border-radius: 16px;\n  }\n\n  .version-header {\n    padding: 16px;\n\n    h2 {\n      font-size: 18px;\n      padding-right: 40px;\n    }\n\n    .subtitle {\n      font-size: 12px;\n    }\n\n    button[mat-icon-button] {\n      top: 8px;\n      right: 8px;\n      background: transparent !important;\n      border: none !important;\n      box-shadow: none !important;\n    }\n  }\n\n  .version-list {\n    max-height: 200px;\n  }\n\n  .comparison-list {\n    max-height: 220px;\n  }\n\n  .version-row {\n    padding: 12px 16px;\n    flex-wrap: wrap;\n    gap: 10px;\n\n    .meta {\n      width: 100%;\n    }\n\n    .actions {\n      width: 100%;\n      justify-content: flex-end;\n      margin-left: 0;\n    }\n  }\n\n  .preview-flow-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .preview,\n  .comparison {\n    padding: 16px;\n  }\n}\n\n/* Dark mode: dialog content must match overlay palette; nested .view-flow preview\n   is outside viewflow.component host so page-level view-flow dark rules do not apply. */\n:host-context(body.theme-dark) {\n  .version-panel {\n    background: #111827 !important;\n    box-shadow: 0 35px 70px rgba(0, 0, 0, 0.55);\n  }\n\n  .version-header {\n    background: #111827 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.28) !important;\n\n    h2 {\n      color: #f1f5f9 !important;\n    }\n\n    .subtitle {\n      color: #94a3b8 !important;\n    }\n\n    button[mat-icon-button] mat-icon {\n      color: #cbd5e1 !important;\n    }\n  }\n\n  .version-list,\n  .comparison-list {\n    &::-webkit-scrollbar-thumb {\n      background: rgba(148, 163, 184, 0.35);\n    }\n  }\n\n  .version-row {\n    border-bottom-color: rgba(148, 163, 184, 0.22) !important;\n\n    &.current {\n      background-color: rgba(94, 161, 216, 0.14) !important;\n    }\n\n    &:hover {\n      background-color: rgba(148, 163, 184, 0.08) !important;\n    }\n  }\n\n  .version-title {\n    color: #e2e8f0 !important;\n  }\n\n  .details {\n    color: #94a3b8 !important;\n  }\n\n  .dot {\n    color: #64748b !important;\n  }\n\n  .collab-label {\n    color: #94a3b8 !important;\n  }\n\n  .collab-avatar-wrap {\n    background: #334155 !important;\n    border-color: #1e293b !important;\n    box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.25) !important;\n  }\n\n  .collab-avatar-fallback {\n    color: #cbd5e1 !important;\n  }\n\n  .empty-state {\n    color: #94a3b8 !important;\n  }\n\n  .loading,\n  .error {\n    color: #e2e8f0 !important;\n  }\n\n  /* Keep action buttons clearly styled in dark mode */\n  .actions .mat-mdc-outlined-button.mat-primary,\n  .actions .mat-mdc-stroked-button.mat-primary {\n    --mdc-outlined-button-outline-color: #7bbde8 !important;\n    --mdc-outlined-button-label-text-color: #7bbde8 !important;\n    border-color: #7bbde8 !important;\n    color: #7bbde8 !important;\n    .mdc-button__label { color: #7bbde8 !important; }\n  }\n\n  .actions .mat-mdc-unelevated-button.mat-primary {\n    --mdc-filled-button-container-color: #5ea1d8 !important;\n    background: #5ea1d8 !important;\n    border-color: #5ea1d8 !important;\n    color: #ffffff !important;\n    .mdc-button__label { color: #ffffff !important; }\n  }\n\n  .actions .mat-mdc-outlined-button.mat-warn,\n  .actions .mat-mdc-stroked-button.mat-warn {\n    --mdc-outlined-button-outline-color: #f87171 !important;\n    --mdc-outlined-button-label-text-color: #f87171 !important;\n    border-color: #f87171 !important;\n    color: #f87171 !important;\n    .mdc-button__label { color: #f87171 !important; }\n  }\n\n  .preview {\n    background: #111827 !important;\n    border-top-color: rgba(148, 163, 184, 0.28) !important;\n\n    h3 {\n      color: #f1f5f9 !important;\n    }\n\n    .preview-meta {\n      color: #94a3b8 !important;\n    }\n\n    .preview-body {\n      color: #e2e8f0 !important;\n    }\n\n    .preview-description h4 {\n      color: #f1f5f9 !important;\n    }\n  }\n\n  .comparison {\n    background: #111827 !important;\n    border-top-color: rgba(148, 163, 184, 0.28) !important;\n\n    .comparison-title {\n      color: #f1f5f9 !important;\n    }\n\n    .comparison-hint,\n    .comparison-loading {\n      color: #94a3b8 !important;\n    }\n\n    .comparison-error {\n      color: #fca5a5 !important;\n    }\n\n    .comparison-list li {\n      color: #e2e8f0 !important;\n    }\n  }\n\n  /* ── Diff cards — dark mode ── */\n  .diff-item {\n    &.diff-added {\n      background: rgba(74, 222, 128, 0.12) !important;\n      border-left-color: #4ade80 !important;\n      .diff-badge { background: #4ade80 !important; color: #052e16 !important; }\n      .diff-text  { color: #86efac !important; }\n    }\n    &.diff-removed {\n      background: rgba(248, 113, 113, 0.12) !important;\n      border-left-color: #f87171 !important;\n      .diff-badge { background: #f87171 !important; color: #450a0a !important; }\n      .diff-text  { color: #fca5a5 !important; }\n    }\n    &.diff-changed {\n      background: rgba(251, 191, 36, 0.12) !important;\n      border-left-color: #fbbf24 !important;\n      .diff-badge { background: #fbbf24 !important; color: #451a03 !important; }\n      .diff-text  { color: #fde68a !important; }\n    }\n    &.diff-info {\n      background: rgba(96, 165, 250, 0.12) !important;\n      border-left-color: #60a5fa !important;\n      .diff-badge { background: #60a5fa !important; color: #172554 !important; }\n      .diff-text  { color: #93c5fd !important; }\n    }\n  }\n\n  .preview-description-card,\n  .preview-steps-wrapper {\n    background-color: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    box-shadow: none !important;\n\n    h4 {\n      color: #f1f5f9 !important;\n    }\n  }\n\n  /* Flow version preview: align with view-flow dark styling (see viewflow.component.scss) */\n  .version-panel .view-flow,\n  .version-panel .view-flow .container1,\n  .version-panel .view-flow .flow-layout-container,\n  .version-panel .view-flow .flow-main-grid,\n  .version-panel .view-flow .flow-main-content,\n  .version-panel .view-flow .video-player-section,\n  .version-panel .view-flow .flow-sidebar,\n  .version-panel .view-flow .step-navigation,\n  .version-panel .view-flow .step-scroll,\n  .version-panel .view-flow .steps-list {\n    background: #0f172a !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .version-panel .view-flow .flow-title-sticky {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .version-panel .view-flow .video-title-sticky {\n    color: #ffffff !important;\n  }\n\n  .version-panel .view-flow .description-section {\n    background: #0f172a !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .version-panel .view-flow .description-section h3 {\n    color: #ffffff !important;\n  }\n\n  .version-panel .view-flow .description-content {\n    color: #e2e8f0 !important;\n\n    a {\n      color: #93c5fd !important;\n    }\n  }\n\n  .version-panel .view-flow .no-steps {\n    color: #94a3b8 !important;\n  }\n\n  .version-panel .view-flow .step-navigation .step-btn {\n    background: #f8fafc !important;\n    color: #111827 !important;\n  }\n\n  .version-panel .view-flow .step-navigation .step-btn .step-title,\n  .version-panel .view-flow .step-navigation .step-btn .step-index {\n    color: #111827 !important;\n  }\n\n  .version-panel .view-flow .step-navigation .step-btn mat-icon {\n    color: #111827 !important;\n  }\n\n  .version-panel .view-flow .preview-video-player .img-wrap {\n    background: #020617 !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
